import MuiIconButton from '@material-ui/core/IconButton';
import styled from 'styled-components';

export default styled(MuiIconButton)`
  border-radius: 0;
  white-space: nowrap;
`;
